// src/i18n/index.js
import ru from './ru';
import en from './en';

const isRu = navigator.language?.startsWith('ru');

export const locale = isRu ? 'ru-RU' : 'en-US';

const t = isRu ? ru : en;
export default t;
